var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboardArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "keyboard-arrow-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.12021 14.7105L12.0002 10.8305L15.8802 14.7105C16.2702 15.1005 16.9002 15.1005 17.2902 14.7105C17.6802 14.3205 17.6802 13.6905 17.2902 13.3005L12.7002 8.71047C12.3102 8.32047 11.6802 8.32047 11.2902 8.71047L6.70021 13.3005C6.31021 13.6905 6.31021 14.3205 6.70021 14.7105C7.09021 15.0905 7.73021 15.1005 8.12021 14.7105Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowUp);
export default __webpack_public_path__ + "static/media/keyboard-arrow-up.8ffb9cafecd36a823f67f687db11e030.svg";
export { ForwardRef as ReactComponent };